// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".keyboard-email-shortcuts--key{position:relative;width:auto;padding:.4em .45em;margin-right:12px}.keyboard-email-shortcuts--key:last-child{margin-right:0}", ""]);
// Exports
module.exports = exports;
